export default {
  colors: {
    primary: "#E87305",
    secondary: "#b84d00",
    gray: "#757575",
    grayBackground: "#FAFAFA",
    grayBackground2: "#eeeeee",
    grayBorder: "#F5F5F5",
    grayLight: "#C2C2C2",
    grayDark: "#333333",
    grayMedium: "#D9D9D9",
    grayMedium2: "#515151",
    textError: "#DC3545",
    backgroundError: "rgba(220, 53, 69, 0.06)",
    textLight: "#fff",
    textDark: "#777",
    textGray: "#3a3a3a",
    textGrayMedium: "#adadad",
    white: "#fff",
    black: "#252525",
    footerGray: "#efefef",
  },
  status: {
    pending: "PENDING",
    closed: "CLOSED",
    opened: "OPEN",
    empty: "EMPTY"
  },
  currency: "BRL",
  language: "pt-br"
};
